__turbopack_context__.v({
  "backdrop": "pky0eG_backdrop",
  "benefitsGrid": "pky0eG_benefitsGrid",
  "ctaRow": "pky0eG_ctaRow",
  "description": "pky0eG_description",
  "intro": "pky0eG_intro",
  "layout": "pky0eG_layout",
  "note": "pky0eG_note",
  "plate": "pky0eG_plate",
  "title": "pky0eG_title",
});
